// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"MobileHomeWeather--next-sr-only--2jD7KS8","weatherIcon":"MobileHomeWeather--weatherIcon--2wvE6oM","temp":"MobileHomeWeather--temp--39kV4TM"};